import api from "./api";

export const getDesignations = async (params = {}) => {
  const response = await api.get("employees/designations/", { params });
  return response.data;
};

export const createDesignation = async (data) => {
  const response = await api.post(
    "employees/designations/",
    data
  );

  return response.data;
};

export const updateDesignation = async (
  id,
  data
) => {
  const response = await api.put(
    `employees/designations/${id}/`,
    data
  );

  return response.data;
};

export const deleteDesignation = async (id, password) => {
  const headers = password ? { "X-Confirm-Password": password } : {};
  await api.delete(`employees/designations/${id}/`, { headers, data: { password }, params: { password } });
};